export const useInputStyle = {
    outlined: true,
    flat: true,
    solo: true,
    dense: true,
}

export default useInputStyle
